export default "__VITE_ASSET__CY4O7dCx__"